// Generated by scripts/blender/monorail-sync.py from the 'Monorail' collection in
// Kiwi_world.blend (2026-11-03). Move the curve there and run that, rather than
// nudging numbers here, or the line and the blend part company.
//
// lines: one a spline, each point [x, y, z, in-handle x, y, z, out-handle x, y, z] in the
// viewer's coordinates, the curve the top of the beam. closed: a loop.
// pylons: [line, metres along it, x, z, the ground there, the top of the beam, yaw].
// stations: [line, from, to, the building it runs through] in metres along the line.
// tunnels: [line, metres along it where it goes in, which way the tunnel runs along the
// line (1 on, -1 back), how long the cutting in front of its portal is].
// lifts: [line, metres along it of the station's end it stands past, out (1 past the end the
// line comes out of, -1 the end it goes in at), side (1 the line's right going out, -1 its
// left), the ground under the tower].
//
// What the sync found in the way when it ran:
//   Monorail: a lift up to flats_high's right platform past its out end, 15.0 m up
//   Monorail: a tunnel goes in at 11 m, its cutting 7.7 m long (910 triangles)
//   Monorail: a tunnel goes in at 742 m, its cutting 35.7 m long (3730 triangles)
//   Monorail: the pylon at 108 m moved +6 m along, 1.3 m from Cube.057
//   Monorail: the pylon at 198 m moved +6 m along, -0.7 m from obs_community_workshop
//   Monorail: the pylon at 433 m moved +6 m along, its cap would meet StreetLamp.029
//   Monorail: the pylon at 451 m moved +6 m along, -0.4 m from Cube.056

export const MONORAIL_PATH = {
  lines: [
    { name: 'Monorail', closed: false, points: [
      [-86.0, 16.5, -112.0, -89.998, 16.622, -112.0, -82.002, 16.378, -112.0],
      [-12.996, 14.274, -112.0, -17.964, 14.426, -112.0, -8.027, 14.123, -112.0],
      [-4.0, 14.0, -103.0, -4.0, 14.0, -107.971, -4.0, 14.0, -98.029],
      [-4.0, 14.0, -83.0, -4.0, 14.0, -87.971, -4.0, 14.0, -78.029],
      [5.0, 14.0, -74.0, 0.029, 14.0, -74.0, 9.971, 14.0, -74.0],
      [118.0, 14.0, -74.0, 112.477, 14.0, -74.0, 123.523, 14.0, -74.0],
      [128.0, 14.0, -64.0, 128.0, 14.0, -69.523, 128.0, 14.0, -58.477],
      [128.0, 14.0, 33.0, 128.0, 14.0, 27.477, 128.0, 14.0, 38.523],
      [118.0, 14.0, 43.0, 123.523, 14.0, 43.0, 112.477, 14.0, 43.0],
      [44.0, 14.0, 43.0, 48.418, 14.0, 43.0, 39.582, 14.0, 43.0],
      [36.0, 14.0, 51.0, 36.0, 14.0, 46.582, 36.0, 14.0, 55.418],
      [36.0, 14.0, 68.0, 36.0, 14.0, 62.477, 36.0, 14.0, 73.523],
      [26.0, 14.0, 78.0, 31.523, 14.0, 78.0, 20.477, 14.0, 78.0],
      [-39.0, 14.0, 78.0, -33.477, 14.0, 78.0, -44.523, 14.0, 78.0],
      [-49.0, 14.0, 68.0, -49.0, 14.0, 73.523, -49.0, 14.0, 62.477],
      [-49.0, 14.0, 32.0, -49.0, 14.0, 36.418, -49.0, 14.0, 27.582],
      [-42.926, 14.0, 18.794, -46.281, 14.0, 21.669, -39.571, 14.0, 15.918],
      [-41.074, 14.0, 17.206, -44.429, 14.0, 20.082, -37.719, 14.0, 14.331],
      [-35.0, 14.21, 4.003, -35.0, 14.094, 8.42, -35.0, 14.327, -0.414],
      [-35.0, 15.763, -55.003, -35.0, 15.632, -50.034, -35.0, 15.894, -59.972],
      [-43.988, 15.542, -64.0, -39.024, 15.795, -64.0, -48.953, 15.29, -64.0],
      [-90.0, 13.2, -64.0, -86.005, 13.403, -64.0, -93.995, 12.997, -64.0],
    ] },
  ],
  pylons: [
    [0, 36.091, -49.926, -112.0, 0.325, 15.4, 0.0],
    [0, 54.136, -31.889, -112.0, -0.014, 14.85, 0.0],
    [0, 72.182, -13.852, -112.0, -0.014, 14.3, 0.0],
    [0, 90.227, -4.0, -99.95, -0.014, 14.0, -1.5708],
    [0, 114.288, -1.334, -76.607, -0.014, 14.0, -0.7814],
    [0, 126.318, 10.002, -74.0, -0.014, 14.0, 0.0],
    [0, 180.454, 64.139, -74.0, -0.014, 14.0, 0.0],
    [0, 204.515, 88.199, -74.0, -0.014, 14.0, 0.0],
    [0, 216.545, 100.23, -74.0, -0.014, 14.0, 0.0],
    [0, 234.591, 118.275, -73.996, -0.014, 14.0, -0.0275],
    [0, 252.636, 128.0, -61.389, -0.014, 14.0, -1.5708],
    [0, 270.682, 128.0, -43.344, -0.014, 14.0, -1.5708],
    [0, 288.727, 128.0, -25.299, -0.014, 14.0, -1.5708],
    [0, 306.773, 128.0, -7.253, -0.014, 14.0, -1.5708],
    [0, 324.818, 128.0, 10.792, -0.014, 14.0, -1.5708],
    [0, 342.864, 128.0, 28.838, -0.014, 14.0, -1.5708],
    [0, 360.909, 119.817, 42.835, -0.014, 14.0, -2.9608],
    [0, 378.954, 101.781, 43.0, -0.014, 14.0, 3.1416],
    [0, 397.0, 83.736, 43.0, -0.006, 14.0, 3.1416],
    [0, 415.045, 65.69, 43.0, 0.068, 14.0, 3.1416],
    [0, 439.106, 41.664, 43.347, 0.382, 14.0, -2.8452],
    [0, 457.151, 36.0, 58.848, 0.526, 14.0, -1.5708],
    [0, 469.182, 35.591, 70.839, 0.729, 14.0, -1.8581],
    [0, 487.227, 20.786, 78.0, 0.758, 14.0, 3.1416],
    [0, 505.273, 2.741, 78.0, 0.7, 14.0, 3.1416],
    [0, 523.318, -15.305, 78.0, 0.5, 14.0, 3.1416],
    [0, 541.363, -33.35, 78.0, 0.352, 14.0, 3.1416],
    [0, 559.409, -48.458, 71.254, 0.445, 14.0, 1.9022],
    [0, 577.454, -49.0, 53.269, 0.448, 14.0, 1.5708],
    [0, 595.5, -49.0, 35.223, 0.438, 14.0, 1.5708],
    [0, 613.545, -42.989, 18.849, 0.4, 14.0, 0.7197],
    [0, 631.591, -35.05, 5.074, 0.176, 14.183, 1.4819],
    [0, 649.636, -35.0, -12.964, 0.576, 14.657, 1.5708],
    [0, 667.682, -35.0, -31.003, 7.304, 15.132, 1.5708],
    [0, 685.727, -35.0, -49.043, 7.338, 15.606, 1.5708],
  ],
  stations: [
    [0, 136.783, 163.637, 'flats_high'],
  ],
  tunnels: [
    [0, 11.0, -1, 7.7],
    [0, 742.0, 1, 35.7],
  ],
  lifts: [
    [0, 163.637, 1, 1, -0.024],
  ],
}
